module.exports = __webpack_public_path__ + "img/marker-point-verde-azulado.9efea9c6.png";